import type { TyreLayoutSubjectKind } from '@chukua/common';

/** The colours a particular vehicle overrides in its palette; none for a class or type drawn on its own. */
export interface VehicleColours {
  cab?: string;
  /** A trailer's bodywork: a tanker's barrel bands, a side-wall's boards, a tipper's body. A container is cargo, not the trailer's paint, so it keeps its own. */
  body?: string;
}

/** A vehicle's own paint (its record's `color`) where the model shows it: a truck's cab, a trailer's body. */
export function vehicleColours(kind: TyreLayoutSubjectKind, color: string | null | undefined): VehicleColours {
  if (!color) return {};
  return kind === 'truck_class' ? { cab: color } : { body: color };
}

/** A rig's paint: its truck's cab and its trailer's body, each from its own record. */
export function rigColours(rig: { truck: { color: string } | null; trailer: { color: string } | null } | undefined): VehicleColours {
  return { ...vehicleColours('truck_class', rig?.truck?.color), ...vehicleColours('trailer_type', rig?.trailer?.color) };
}
